import {
  bindLogoutCleanup,
  persistIdentitySession,
  syncIdentitySession
} from './hubspot_session';

const SCRIPT_TAG = 'script';

if (typeof window.isHubSpotLoaded === 'undefined') {
  window.isHubSpotLoaded = false;
}

function currentUserEmail() {
  return (window.currentUser && window.currentUser.email) || null;
}

function log(message) {
  if (RAILS_ENV === 'production') {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(message);
}

function identify() {
  if (window.currentUser) {
    log('Identifying user with HubSpot');
    var _hsq = (window._hsq = window._hsq || []);
    _hsq.push([
      'identify',
      {
        email: window.currentUser.email,
        id: window.currentUser.id,
        qc_subscription_api: window.currentUser.subscriptionStatus
      }
    ]);

    // Abençoa o utk atual para este e-mail; o marcador é o que permite ao
    // syncIdentitySession detectar troca de dono no próximo boot.
    persistIdentitySession(window.currentUser.email);
  }
}

async function startHubSpotScript(
  id = 'hs-script-loader',
  src = '//js.hs-scripts.com/44326808.js'
) {
  return new Promise((resolve, reject) => {
    const lastScriptElement = document.getElementsByTagName(SCRIPT_TAG)[0];
    const scriptElement = document.createElement(SCRIPT_TAG);

    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.id = id;
    scriptElement.onload = () => resolve();
    scriptElement.onerror = error => reject(error);
    scriptElement.src = src;
    lastScriptElement.parentNode.insertBefore(scriptElement, lastScriptElement);
  });
}

function bindTurbolinks() {
  document.addEventListener('turbolinks:load', () => {
    log('Tracking Hubspot page view with turbolinks:load event');

    // Login/logout no odin também acontecem via navegação Turbolinks, então a
    // troca de dono do navegador precisa ser checada aqui, não só no boot.
    syncIdentitySession(currentUserEmail());

    identify();
    var _hsq = (window._hsq = window._hsq || []);
    _hsq.push(['setPath', location.pathname + location.search]);
    _hsq.push(['trackPageView']);

    startHubSpotScript().then(() => {
      log('HubSpot script reloaded');

      // Se o sync acima zerou os cookies, o utk novo só existe depois do
      // script recarregar — abençoa aqui, não só no identify.
      persistIdentitySession(currentUserEmail());
    });
  });

  document.addEventListener('turbolinks:before-visit', () => {
    const webInteractiveEmbed =
      'script[src="https://js.hubspot.com/web-interactives-embed.js"]';
    const el = document.querySelector(webInteractiveEmbed);

    if (el) {
      window.hubspot_web_interactives_running = false;
      el.remove();
      log('Removing web-interactives-embed.js script tag');
    }

    const hsScript = 'script[src="//js.hs-scripts.com/44326808.js"]';
    const el2 = document.querySelector(hsScript);

    if (el2) {
      window.hubspot_web_interactives_running = false;
      el2.remove();
      log('Removing hs-scripts.com script tag');
    }
  });
}

function onLoaded() {
  window.isHubSpotLoaded = true;
  log('HubSpot loaded');
  identify();
  bindTurbolinks();
}

if (!window.isHubSpotLoaded) {
  // Antes de injetar o script: se o navegador pertence a outro contato (troca
  // de conta) ou o utk nunca foi validado, zera os cookies do HubSpot para o
  // utk novo nascer amarrado ao usuário atual — o identify não re-associa um
  // utk que já tem dono, e a entrega de CTAs resolve o contato só pelo utk.
  syncIdentitySession(currentUserEmail());
  bindLogoutCleanup();

  Promise.all([startHubSpotScript()].filter(Boolean))
    .then(() => onLoaded())
    // .catch(err => Rollbar.error('Erro ao inicializar HubSpot', err));
    .catch(() => log('Erro ao inicializar HubSpot'));
}
